import { isEmpty, isNil, omitBy } from 'lodash'

import { Filter } from '@/types/graphql-generated-types'

type NullableRange =
  | {
      from?: number | null
      to?: number | null
    }
  | null
  | undefined

const mapRange = (range: NullableRange) => {
  if (!range) return undefined
  if (!range.from && !range.to) return undefined

  return {
    from: range.from || null,
    to: range.to || null,
  }
}

const mapAmenities = (filters: Filter) => {
  const amenities = {
    balcony: filters?.onlyWithBalcony,
    basement: filters?.onlyWithBasement,
    box: filters?.onlyWithBox,
    conciergeService: filters?.onlyWithConciergeService,
    coolingSystem: filters?.onlyWithCoolingSystem,
    elevator: filters?.onlyWithElevator,
    garden: filters?.onlyWithGarden,
    parking: filters?.onlyWithParking,
    pool: filters?.onlyWithPool,
    terrace: filters?.onlyWithTerrace,
  }
  const reducedAmenities = omitBy(amenities, isNil)

  return isEmpty(reducedAmenities) ? undefined : reducedAmenities
}

type ReducedSearchPayload = { [key: string]: any } & { onlyCasavo: boolean }

export const mapForFavoriteSearch = (filters: Filter): ReducedSearchPayload => {
  const searchCriteria = {
    area: mapRange(filters?.byArea),
    bathrooms: mapRange(filters?.byBathrooms),
    bedrooms: mapRange(filters?.byBedrooms),
    constructionYear: mapRange(filters?.byConstructionYear),
    floor: filters?.byFloor,
    heatingSystem: filters?.byHeatingSystem,
    mustHaveAmenities: mapAmenities(filters),
    price: mapRange(filters?.byPrice),
    residentialType: filters?.byResidentialType,
    rooms: mapRange(filters?.byRooms),
    stateAtDeed: filters?.byStateAtDeed,
    stateOfMaintenance: filters?.byStateOfMaintenance,
  }
  return {
    ...omitBy(searchCriteria, isNil),
    onlyCasavo: filters?.onlyCasavo || false,
  }
}
